import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trophy } from "@phosphor-icons/react";
import { useFetch } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const LeaderboardOptIn = () => {
  const { data: d, reload } = useFetch("/me/leaderboard");
  if (!d) return null;
  const toggle = async (v) => {
    try { await api.put("/me/leaderboard", { opt_in: v }); toast.success(v ? "You're on the leaderboard" : "Removed from the leaderboard"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="panel mt-4 grid gap-4 p-5 md:grid-cols-[1fr,auto]" data-testid="leaderboard-optin-card">
      <div>
        <h3 className="flex items-center gap-2 font-display text-xl font-bold uppercase"><Trophy className="text-[#E0A21B]" /> City leaderboard</h3>
        <p className="mt-1 text-sm text-[#475569]">Show up on the public <Link to="/leaderboard" className="underline" target="_blank">leaderboard</Link> as <strong data-testid="leaderboard-preview-name">{d.preview}</strong>. Only your first name, last initial and city are shown. Turn it off any time and you disappear right away.</p>
        {d.hidden_by_staff && d.opt_in && <p className="mt-2 text-xs text-[#C8382E]" data-testid="leaderboard-hidden-note">Your entry is currently hidden by our team. Contact support if you have questions.</p>}
        <div className="mt-3 text-sm" data-testid="leaderboard-my-rank">
          {!d.season ? <span className="text-[#475569]">No season is running right now.</span>
            : d.ranks.length === 0 ? <span className="text-[#475569]">{d.season.name}: no friends have checked in yet. Your rank appears here privately once they do.</span>
            : d.ranks.map((r) => <div key={r.city_name} data-testid={`my-rank-${r.city_name}`}><span className="font-semibold">{r.city_name}:</span> you are #{r.rank} with {r.count} friend{r.count === 1 ? "" : "s"} attended{!d.opt_in ? " (only you can see this)" : r.in_top10 ? "" : " (top 10 are shown publicly)"}</div>)}
        </div>
      </div>
      <label className="flex items-center gap-3 self-start text-sm font-semibold">
        <Switch checked={d.opt_in} onCheckedChange={toggle} data-testid="leaderboard-optin-switch" /> {d.opt_in ? "On" : "Off"}
      </label>
    </div>
  );
};
